"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var react_i18next_1 = require("react-i18next");
var BlToggle = function (_a) {
    var options = _a.options, name = _a.name, value = _a.value, onChange = _a.onChange, className = _a.className;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.switch, className) },
        options.map(function (option) {
            return (react_1.default.createElement(react_1.Fragment, { key: option.text },
                react_1.default.createElement("input", { type: "radio", className: styles_module_scss_1.default.switch_input, name: name, id: option.text, value: option.text, checked: value === option.text, onChange: function () {
                        onChange(option);
                    } }),
                react_1.default.createElement("label", { htmlFor: option.text, className: styles_module_scss_1.default.switch_label }, t(option.text))));
        }),
        react_1.default.createElement("span", { className: styles_module_scss_1.default.switch_selection })));
};
exports.default = BlToggle;
